import { ChangeDetectorRef, Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { DeviceService } from '../service/device.service';
import { Overlay } from "@angular/cdk/overlay";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { PeriodicExecution } from '../model/periodicExecution';
import { MatTableDataSource } from '@angular/material/table';
import { DevicePilomat } from '../model/devicePilomat';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../service/user.service';
import { AddAutomationComponent } from '../add-automation/add-automation.component';
import { Automation } from '../model/automation';
import { Log } from '../util/log';
import { AppComponent } from '../app.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-automations',
  templateUrl: './automations.component.html',
  styleUrls: ['./automations.component.css']
})
export class AutomationsComponent implements OnInit, AfterViewInit {

  devices: DevicePilomat[] = [];
  devicesWithExecutions: DevicePilomat[] = [];
  devicesWithoutExecutions: DevicePilomat[] = [];


  allDevices: DevicePilomat[] = [];
  deviceNameMap = new Map<string, string>();
  deviceAutomationCounter = new Map<string, number>();

  hasExecutions: boolean = false;

  owneruid: string = "";

  isUserService: boolean = false;

  @Input() filter: string;
  @Input() userCanExecutionEdit: boolean;

  automations: Automation[] = [];

  @ViewChild('automationsTable', { static: true }) table;
  @ViewChild('automationsloader', { static: true }) loader;

  @ViewChild(MatSort) sort!: MatSort;


  displayedColumnsAutomations: string[] = [
    'serial',
    'deviceReference',
    'name',
    'startDateFriendly',
    'expirationDateFriendly',
    'daysAllowed',
    'hoursAllowed',
    'deleteAutomation'
  ];

  closeToastString: string = $localize`:@@automations_close:chiudi`;

  constructor(
    public appComponent: AppComponent,
    private deviceService: DeviceService,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private overlay: Overlay,
  ) { }

  ngOnInit(): void {
  }


  ngAfterViewInit() {
    this.loader.showLoading();

    this.isUserService = this.isService()
    Log.debug('\n\n\n\t\t\tthis.isUserService: ' + this.isUserService);


    setTimeout(() => {
      // attesa per attendere che carichi se è service
    }, 300);


    if (this.isUserService) {
      Log.debug('\n\n\n\t\t\tparamMap: ' + JSON.stringify(this.route.snapshot.paramMap));

      this.owneruid = this.route.snapshot.paramMap.get('uid');
      Log.debug('\n\n\n\t\t\towner: ' + this.owneruid);


    } else {

      this.owneruid = this.userService.meUser.uid;

    }


    setTimeout(() => { this.getDevices(); }, 1500);
    // this.getDevices();
  }

  isService(): boolean {
    return this.appComponent.isService();
  }

  filterAutomations(data: Automation, filter: string): boolean {
    if (data.serial && data.serial.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.description && data.description.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.name && data.name.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.deviceReference && data.deviceReference.toLowerCase().indexOf(filter) != -1) {
      return true;
    }


    if (data.hoursAllowed && data.hoursAllowed.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.daysAllowed && data.daysAllowed.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.startDateFriendly && data.startDateFriendly.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.expirationDateFriendly && data.expirationDateFriendly.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    if (data.result && data.result.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }

  getDevices() {
    this.deviceService.getDevices().subscribe(data => {

      for (let device of data) {
        this.allDevices.push(device);
        this.deviceNameMap.set(device.serial, device.systemInfo.reference);


        if (device.systemInfo.version >= DevicePilomat.MIN_VER_FORCEDLOW_REASON) {
          this.devices.push(device);
        }
      }

      this.cdRef.detectChanges();
      this.getAutomations();
    });
  }


  addAutomation() {
    this.loader.showLoading();

    this.checkForExecutions();

    setTimeout(() => {
      //waiting to check
      this.loader.hideLoading();

      if (this.hasExecutions) {

        let devicesWithExecutionsString = ""
        for (let device of this.devicesWithExecutions) {
          devicesWithExecutionsString += device.serial + ", ";
        }

        devicesWithExecutionsString = devicesWithExecutionsString.slice(0, -2);

        let message = $localize`:@@automation_dialog_executions_found_for_devices:Per poter creare delle automazioni per un dispositivo é necessario eliminare tutti i suoi automatismi presenti. Sono stati trovati trovati automatismi per i seguenti dispositivi:` + " " + devicesWithExecutionsString;
        let header = $localize`:@@automation_dialog_executions_found_warning:Attenzione`;

        const scrollStrategy = this.overlay.scrollStrategies.reposition();

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '450px',
          data: { message, header },
          scrollStrategy,
        });

        dialogRef.afterClosed().subscribe((response) => {

          if (this.devicesWithoutExecutions.length > 0) {

            this.checkAutomationsCounter();

          }

        });

      } else {

        this.checkAutomationsCounter();
      }
    }, 1000);
  }


  checkAutomationsCounter() {

    let automationsLimitReached = false;
    let devicesWith10AutomationsString = "";

    for (let device of this.devicesWithoutExecutions) {

      if (this.deviceAutomationCounter.get(device.serial) >= 10) {
        automationsLimitReached = true;

        const i = this.devicesWithoutExecutions.findIndex(d => d.serial === device.serial);
        if (i > -1) {
          this.devicesWithoutExecutions.splice(i, 1);
        }

        devicesWith10AutomationsString += device.serial + ", ";
      }
    }

    if (automationsLimitReached) {
      devicesWith10AutomationsString = devicesWith10AutomationsString.slice(0, -2);

      let message = $localize`:@@automation_dialog_limit_reached_for_devices:Per ciascun device è possibile creare un massimo di 10 automatismi. I seguenti device hanno raggiunto il limite:` + " " + devicesWith10AutomationsString;
      let header = $localize`:@@automation_dialog_limit_reached_warning:Attenzione`;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '450px',
        data: { message, header },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {

        if (this.devicesWithoutExecutions.length > 0) {

          this.openAddExecutionDialog();

        }

      });

    } else {

      this.openAddExecutionDialog();

    }


  }

  openAddExecutionDialog() {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(AddAutomationComponent, {
      width: "1100px",
      data: { devices: this.devicesWithoutExecutions },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == "Success") {
        this.loader.showLoading();
        let snackBarRef = this.snackBar.open($localize`:@@automations_creation_success:Automatismo creato con successo`, this.closeToastString, {
          duration: 3000
        });
        this.getAutomations();
      } else if (result == "Error") {
        let snackBarRef = this.snackBar.open($localize`:@@automations_creation_error:Errore nella creazione degli automatismi`, this.closeToastString, {
          duration: 3000
        });
        this.loader.showError();
      }
    });
  }

  onKey(event: any) {
    this.filter = event.target.value;
    this.table.dataSource.filter = this.filter.trim().toLowerCase();
  }

  getAutomations() {
    this.loader.showLoading();
    this.automations = [];

    this.deviceService.getAutomations(this.owneruid).subscribe((response) => {

      Log.debug("Automations received: ");
      Log.debug(response);

      this.automations = response;

      this.deviceAutomationCounter.clear();

      Log.debug("Automations counter after clear: ");
      Log.debug(this.deviceAutomationCounter);

      for (let automation of this.automations) {

        if (this.deviceAutomationCounter.has(automation.serial)) {

          let oldCount = this.deviceAutomationCounter.get(automation.serial);
          this.deviceAutomationCounter.set(automation.serial, oldCount + 1);

        } else {
          this.deviceAutomationCounter.set(automation.serial, 1);
        }

        if (this.deviceNameMap.has(automation.serial)) {
          automation.deviceReference = this.deviceNameMap.get(automation.serial);
        }
      }

      Log.debug("Automations after name assign: ");
      Log.debug(this.automations);


      Log.debug("Automations counter: ");
      Log.debug(this.deviceAutomationCounter);

      this.table.dataSource = new MatTableDataSource(this.automations);
      this.table.dataSource.filterPredicate = this.filterAutomations;
      this.table.dataSource.sort = this.sort;

      this.table.dataSource.sortingDataAccessor = (item: any, property: string) => {
        try {
          if (property === 'startDateFriendly') {
            const raw = item.startDate ?? item.startDateDate ?? item[property];
            const d = (raw instanceof Date) ? raw : new Date(raw);
            return isNaN(d.getTime()) ? 0 : d.getTime();
          }
          if (property === 'expirationDateFriendly') {
            const raw = item.expirationDate ?? item.expirationDateDate ?? item[property];
            const d = (raw instanceof Date) ? raw : new Date(raw);
            // for missing expiration dates, return large value so they appear last when sorting asc
            return isNaN(d.getTime()) ? Number.MAX_SAFE_INTEGER : d.getTime();
          }
        } catch (e) {
          // fallback to default
        }
        return item[property];
      };

      setTimeout(() => {
        this.loader.hideLoading();
      }, 250);

    }, (err) => {
      console.log(err);
      this.loader.showError();
    });

  }

  // checkForExecutions() {
  //   this.findAnyExecution().then(found => {
  //     this.hasExecutions = found;
  //     Log.debug("\n\n\tthis.hasExecutions");
  //     Log.debug(this.hasExecutions);
  //   });
  // }

  // findAnyExecution(): Promise<boolean> {
  //   return new Promise(resolve => {
  //     if (!this.devices || this.devices.length === 0) {
  //       resolve(false);
  //     } else {
  //       this.checkDeviceAtIndex(0, resolve);
  //     }
  //   });
  // }

  // private checkDeviceAtIndex(index: number, resolve: (value: boolean) => void): void {
  //   if (index >= this.devices.length) {
  //     resolve(false);
  //     return;
  //   }

  //   const device = this.devices[index];

  //   this.deviceService.getProgrammedExecution(device.serial).subscribe({
  //     next: data => {
  //       if (data && data.length > 0) {
  //         resolve(true);
  //       } else {
  //         this.deviceService.getPeriodicExecution(device.serial).subscribe({
  //           next: periodicData => {
  //             if (periodicData && periodicData.length > 0) {
  //               resolve(true);
  //             } else {
  //               this.checkDeviceAtIndex(index + 1, resolve);
  //             }
  //           },
  //           error: () => this.checkDeviceAtIndex(index + 1, resolve)
  //         });
  //       }
  //     },
  //     error: () => this.checkDeviceAtIndex(index + 1, resolve)
  //   });
  // }

  checkForExecutions(): void {
    this.devicesWithExecutions = [];
    this.devicesWithoutExecutions = this.devices ? JSON.parse(JSON.stringify(this.devices)) : [];

    if (!this.devices || this.devices.length === 0) {
      this.hasExecutions = false;
      return;
    }

    this.processDeviceAtIndex(0);
  }

  private processDeviceAtIndex(index: number): void {
    if (index >= this.devices.length) {
      this.hasExecutions = this.devicesWithExecutions.length > 0;
      return;
    }

    const device = this.devices[index];

    const finalizeAndContinue = (hasExecution: boolean) => {
      if (hasExecution) {
        this.devicesWithExecutions.push(device);
        const i = this.devicesWithoutExecutions.findIndex(d => d.serial === device.serial);
        if (i > -1) {
          this.devicesWithoutExecutions.splice(i, 1);
        }
      }
      this.processDeviceAtIndex(index + 1);
    };

    const checkPeriodic = () => {
      this.deviceService.getPeriodicExecution(device.serial).subscribe({
        next: periodicData => finalizeAndContinue(periodicData && periodicData.length > 0),
        error: () => finalizeAndContinue(false)
      });
    };

    this.deviceService.getProgrammedExecution(device.serial).subscribe({
      next: data => {
        if (data && data.length > 0) {
          finalizeAndContinue(true);
        } else {
          checkPeriodic();
        }
      },
      error: () => checkPeriodic()
    });
  }


  deleteAutomation(execution: Automation) {
    let message = $localize`:@@automation_dialog_confirm2:Desideri eliminare l'automazione ` + execution.name + " ?";
    let confirmMessage = $localize`:@@automation_dialog_confirm_yes:Sì, elimina`;
    let cancelMessage = $localize`:@@automation_dialog_confirm_no:No, annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.loader.showLoading();
        this.deviceService.deleteAutomation(execution.serial, execution.id).subscribe((response) => {
          let snackBarRef = this.snackBar.open($localize`:@@automations_deletion_success:Automazione eliminata con successo`, this.closeToastString, {
            duration: 3000
          });
          this.getAutomations();
        }, (err) => {
          console.log(err);
          let snackBarRef = this.snackBar.open($localize`:@@automations_delete_error:Sì è verificato un errore nell'eliminazione dell'automazione, riprovare più tardi`, this.closeToastString, {
            duration: 3000
          });
        });
      }
    });
  }

}

